module.exports = __webpack_public_path__ + "media/icons/chevron-menu-65124b22.svg";